<template>
  <div>
    <b class="success--text" v-if="secondaryrequired">{{
      $format.decimal(primary)
    }}</b>
    <!-- <br />
    <small>{{ $format.decimal(secondary) }}</small> -->
  </div>
</template>

<script>

export default {
  name: "InfoDecimalCell",
  props: {
    primary: {
      type: [Number, String],
      required: true,
    },
    secondary: {
      type: [Number, String],
      required: false,
      default: null,
    },
    secondaryrequired: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

// esta send usando na table de att em massa //
views/products/ProductMassUpdateIndex
